// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_exn = require("rescript/lib/js/js_exn.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Webapi__Dom__Node = require("rescript-webapi/src/Webapi/Dom/Webapi__Dom__Node.bs.js");
var Webapi__Dom__Text = require("rescript-webapi/src/Webapi/Dom/Webapi__Dom__Text.bs.js");
var Util$SmartcutsMacros = require("../../../bs-utils/src/Util.bs.js");
var Webapi__Dom__Element = require("rescript-webapi/src/Webapi/Dom/Webapi__Dom__Element.bs.js");
var Selector$SmartcutsMacros = require("../Selector.bs.js");
var OptionUtils$SmartcutsMacros = require("../../../bs-utils/src/OptionUtils.bs.js");
var StringUtils$SmartcutsMacros = require("../../../bs-utils/src/StringUtils.bs.js");
var TextContents$SmartcutsMacros = require("../TextContents.bs.js");
var Selection__Snapshot$SmartcutsMacros = require("./Selection__Snapshot.bs.js");
var DomElementIdentifierGenerator$SmartcutsMacros = require("../DomElementIdentifierGenerator.bs.js");
var DomElementIdentifierPaired__WithSelector$SmartcutsMacros = require("../DomElementIdentifierPaired__WithSelector.bs.js");

function t_encode(v) {
  return Js_dict.fromArray([
              [
                "siblingIndex",
                Decco.intToJson(v.siblingIndex)
              ],
              [
                "text",
                Decco.stringToJson(v.text)
              ]
            ]);
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var siblingIndex = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "siblingIndex"), null));
  if (siblingIndex.TAG === /* Ok */0) {
    var text = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "text"), null));
    if (text.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                siblingIndex: siblingIndex._0,
                text: text._0
              }
            };
    }
    var e = text._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".text" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = siblingIndex._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".siblingIndex" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function stringify(param) {
  return "{siblingIndex: " + (String(param.siblingIndex) + (", text: " + (StringUtils$SmartcutsMacros.quote(param.text) + "}")));
}

var TextNode = {
  t_encode: t_encode,
  t_decode: t_decode,
  stringify: stringify
};

function t_encode$1(encoder_domElementRepresentation, v) {
  return Js_dict.fromArray([
              [
                "domElementRepresentation",
                Curry._1(encoder_domElementRepresentation, v.domElementRepresentation)
              ],
              [
                "childTextNodes",
                Decco.arrayToJson(t_encode, v.childTextNodes)
              ]
            ]);
}

function t_decode$1(decoder_domElementRepresentation, v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var domElementRepresentation = Curry._1(decoder_domElementRepresentation, Belt_Option.getWithDefault(Js_dict.get(dict$1, "domElementRepresentation"), null));
  if (domElementRepresentation.TAG === /* Ok */0) {
    var childTextNodes = Decco.arrayFromJson(t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "childTextNodes"), null));
    if (childTextNodes.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                domElementRepresentation: domElementRepresentation._0,
                childTextNodes: childTextNodes._0
              }
            };
    }
    var e = childTextNodes._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".childTextNodes" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = domElementRepresentation._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".domElementRepresentation" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function stringify$1(stringifyDomElementRepresentation, param) {
  return "{domElementRepresentation: " + (Curry._1(stringifyDomElementRepresentation, param.domElementRepresentation) + (", childTextNodes: " + (StringUtils$SmartcutsMacros.join(", ", $$Array.to_list(Belt_Array.map(param.childTextNodes, stringify))) + "}")));
}

var ElementNode = {
  t_encode: t_encode$1,
  t_decode: t_decode$1,
  stringify: stringify$1
};

function t_encode$2(v) {
  return t_encode$1(DomElementIdentifierPaired__WithSelector$SmartcutsMacros.t_encode, v);
}

function t_decode$2(v) {
  return t_decode$1(DomElementIdentifierPaired__WithSelector$SmartcutsMacros.t_decode, v);
}

function fromDomElement(domElementIdentifierGenerator, element) {
  var selector = Selector$SmartcutsMacros.forDomElement(element);
  var childNodes = element.childNodes;
  var childTextNodes = OptionUtils$SmartcutsMacros.arrayOfOptionsToArrayOfUnboxedSomes($$Array.mapi((function (siblingIndex, node) {
              var textNode = Webapi__Dom__Text.ofNode(node);
              if (textNode === undefined) {
                return ;
              }
              var text = Caml_option.valFromOption(textNode).data;
              return {
                      siblingIndex: siblingIndex,
                      text: text
                    };
            }), Array.prototype.slice.call(childNodes)));
  var domElementIdentifier = DomElementIdentifierGenerator$SmartcutsMacros.identifierForElement(element, domElementIdentifierGenerator);
  return {
          domElementRepresentation: {
            domElementIdentifier: domElementIdentifier,
            selector: selector
          },
          childTextNodes: childTextNodes
        };
}

function updateSelector(f, node) {
  var domElementRepresentation = node.domElementRepresentation;
  return {
          domElementRepresentation: {
            domElementIdentifier: domElementRepresentation.domElementIdentifier,
            selector: Curry._1(f, domElementRepresentation.selector)
          },
          childTextNodes: node.childTextNodes
        };
}

var ElementNodeForRecording = {
  t_encode: t_encode$2,
  t_decode: t_decode$2,
  fromDomElement: fromDomElement,
  updateSelector: updateSelector
};

function t_encode$3(v) {
  return t_encode$1(Selector$SmartcutsMacros.selector_encode, v);
}

function t_decode$3(v) {
  return t_decode$1(Selector$SmartcutsMacros.selector_decode, v);
}

function fromElementNodeForRecording(elementNode) {
  return {
          domElementRepresentation: elementNode.domElementRepresentation.selector,
          childTextNodes: elementNode.childTextNodes
        };
}

function updateSelector$1(f, node) {
  return {
          domElementRepresentation: Curry._1(f, node.domElementRepresentation),
          childTextNodes: node.childTextNodes
        };
}

var ElementNodeForNonRecording = {
  t_encode: t_encode$3,
  t_decode: t_decode$3,
  fromElementNodeForRecording: fromElementNodeForRecording,
  updateSelector: updateSelector$1
};

function t_encode$4(encoder_domElementRepresentation, v) {
  return Js_dict.fromArray([
              [
                "elementNode",
                t_encode$1(encoder_domElementRepresentation, v.elementNode)
              ],
              [
                "textNode",
                Decco.optionToJson(t_encode, v.textNode)
              ],
              [
                "offset",
                Decco.intToJson(v.offset)
              ]
            ]);
}

function t_decode$4(decoder_domElementRepresentation, v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var elementNode = t_decode$1(decoder_domElementRepresentation, Belt_Option.getWithDefault(Js_dict.get(dict$1, "elementNode"), null));
  if (elementNode.TAG === /* Ok */0) {
    var textNode = Decco.optionFromJson(t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "textNode"), null));
    if (textNode.TAG === /* Ok */0) {
      var offset = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "offset"), null));
      if (offset.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  elementNode: elementNode._0,
                  textNode: textNode._0,
                  offset: offset._0
                }
              };
      }
      var e = offset._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".offset" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = textNode._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".textNode" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = elementNode._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".elementNode" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function stringify$2(stringifyDomElementRepresentation, param) {
  return "{elementNode: " + (stringify$1(stringifyDomElementRepresentation, param.elementNode) + (", textNode: " + (OptionUtils$SmartcutsMacros.withDefault("undefined", OptionUtils$SmartcutsMacros.map(param.textNode, stringify)) + (", offset: " + (String(param.offset) + "}")))));
}

function extractElementNode(boundary) {
  return boundary.elementNode;
}

function extractTextAndOffset(boundary) {
  return [
          OptionUtils$SmartcutsMacros.withDefault("", OptionUtils$SmartcutsMacros.map(boundary.textNode, (function (textNode) {
                      return textNode.text;
                    }))),
          boundary.offset
        ];
}

function isSame(isDomElementRepresentationEqual, param, param$1) {
  var textNodeB = param$1.textNode;
  var textNodeA = param.textNode;
  if (Curry._2(isDomElementRepresentationEqual, param.elementNode.domElementRepresentation, param$1.elementNode.domElementRepresentation)) {
    if (textNodeA !== undefined) {
      if (textNodeB !== undefined) {
        return textNodeA.siblingIndex === textNodeB.siblingIndex;
      } else {
        return false;
      }
    } else {
      return textNodeB === undefined;
    }
  } else {
    return false;
  }
}

var SelectionBoundary = {
  t_encode: t_encode$4,
  t_decode: t_decode$4,
  stringify: stringify$2,
  extractElementNode: extractElementNode,
  extractTextAndOffset: extractTextAndOffset,
  isSame: isSame
};

function t_encode$5(v) {
  return t_encode$4(DomElementIdentifierPaired__WithSelector$SmartcutsMacros.t_encode, v);
}

function t_decode$5(v) {
  return t_decode$4(DomElementIdentifierPaired__WithSelector$SmartcutsMacros.t_decode, v);
}

function ofTextNodeAndOffset(domElementIdentifierGenerator, textNode, offset) {
  var arg = textNode.parentNode;
  var arg$1 = (arg == null) ? undefined : Caml_option.some(arg);
  var arg$2 = Webapi__Dom__Element.ofNode((function (param) {
            return OptionUtils$SmartcutsMacros.getExn(param, arg$1);
          })("Expected text parent node for Text node in Selection.Cursor.ofNodeAndOffset"));
  var parentElement = (function (param) {
        return OptionUtils$SmartcutsMacros.getExn(param, arg$2);
      })("Expected element node for parent text node in Selection.Cursor.ofNodeAndOffset");
  var arg$3 = Util$SmartcutsMacros.shortcutWithIndex2(Array.prototype.slice.call(parentElement.childNodes), (function (sibling, index) {
          if (Caml_obj.caml_equal(sibling, textNode)) {
            return index;
          }
          
        }));
  var siblingIndex = (function (param) {
        return OptionUtils$SmartcutsMacros.getExn(param, arg$3);
      })("Expected to find Text node among parentElement childNodes in Selection.Cursor.ofNodeAndOffset");
  var elementNode = fromDomElement(domElementIdentifierGenerator, parentElement);
  var text = textNode.data;
  var textNode$1 = {
    siblingIndex: siblingIndex,
    text: text
  };
  return {
          elementNode: elementNode,
          textNode: textNode$1,
          offset: offset
        };
}

function ofNodeAndOffset(domElementIdentifierGenerator, _node, offset) {
  while(true) {
    var node = _node;
    var match = Webapi__Dom__Node.nodeType(node);
    if (match >= 3) {
      return Js_exn.raiseError("Expected nodeType = Element | Text");
    }
    switch (match) {
      case /* Element */0 :
          if (offset === 0) {
            var arg = Webapi__Dom__Element.ofNode(node);
            var element = (function(arg){
              return function (param) {
                return OptionUtils$SmartcutsMacros.getExn(param, arg);
              }
              }(arg))("Expected node");
            return {
                    elementNode: fromDomElement(domElementIdentifierGenerator, element),
                    textNode: undefined,
                    offset: 0
                  };
          }
          var arg$1 = Webapi__Dom__Element.ofNode(node);
          var element$1 = (function(arg$1){
            return function (param) {
              return OptionUtils$SmartcutsMacros.getExn(param, arg$1);
            }
            }(arg$1))("Expected node");
          var node$1 = element$1.firstChild;
          if (node$1 == null) {
            return {
                    elementNode: {
                      domElementRepresentation: {
                        domElementIdentifier: DomElementIdentifierGenerator$SmartcutsMacros.identifierForElement(element$1, domElementIdentifierGenerator),
                        selector: Selector$SmartcutsMacros.forDomElement(element$1)
                      },
                      childTextNodes: []
                    },
                    textNode: undefined,
                    offset: 0
                  };
          }
          if (Webapi__Dom__Node.nodeType(node$1) === /* Text */2) {
            var arg$2 = Webapi__Dom__Text.ofNode(node$1);
            var textNode = (function(arg$2){
              return function (param) {
                return OptionUtils$SmartcutsMacros.getExn(param, arg$2);
              }
              }(arg$2))("SelectionBoundary.ofNodeAndOffset error: Expected to get TextNode if nodeType == Text");
            return ofTextNodeAndOffset(domElementIdentifierGenerator, textNode, offset);
          }
          if (Webapi__Dom__Node.nodeType(node$1) !== /* Element */0) {
            return Util$SmartcutsMacros.logAndRaiseJsError("SelectionBoundary.ofNodeAndOffset error: Expected first child node to be a text or element node");
          }
          _node = node$1;
          continue ;
      case /* Attribute */1 :
          return Js_exn.raiseError("Expected nodeType = Element | Text");
      case /* Text */2 :
          var arg$3 = Webapi__Dom__Text.ofNode(node);
          var textNode$1 = (function(arg$3){
            return function (param) {
              return OptionUtils$SmartcutsMacros.getExn(param, arg$3);
            }
            }(arg$3))("Expected text node for Text node in Selection.Cursor.ofNodeAndOffset");
          return ofTextNodeAndOffset(domElementIdentifierGenerator, textNode$1, offset);
      
    }
  };
}

function isSame$1(param, param$1) {
  return isSame((function (param, param$1) {
                return param.domElementIdentifier === param$1.domElementIdentifier;
              }), param, param$1);
}

function endsOnNode(node, param) {
  return param.elementNode.domElementRepresentation.domElementIdentifier === node.domElementIdentifier;
}

function updateSelector$2(f, boundary) {
  return {
          elementNode: updateSelector(f, boundary.elementNode),
          textNode: boundary.textNode,
          offset: boundary.offset
        };
}

var SelectionBoundaryForRecording = {
  t_encode: t_encode$5,
  t_decode: t_decode$5,
  ofTextNodeAndOffset: ofTextNodeAndOffset,
  ofNodeAndOffset: ofNodeAndOffset,
  isSame: isSame$1,
  endsOnNode: endsOnNode,
  updateSelector: updateSelector$2
};

function t_encode$6(v) {
  return t_encode$4(Selector$SmartcutsMacros.selector_encode, v);
}

function t_decode$6(v) {
  return t_decode$4(Selector$SmartcutsMacros.selector_decode, v);
}

function fromSelectionBoundaryForRecording(boundary) {
  return {
          elementNode: fromElementNodeForRecording(boundary.elementNode),
          textNode: boundary.textNode,
          offset: boundary.offset
        };
}

function updateSelector$3(f, boundary) {
  return {
          elementNode: updateSelector$1(f, boundary.elementNode),
          textNode: boundary.textNode,
          offset: boundary.offset
        };
}

var SelectionBoundaryForNonRecording = {
  t_encode: t_encode$6,
  t_decode: t_decode$6,
  fromSelectionBoundaryForRecording: fromSelectionBoundaryForRecording,
  updateSelector: updateSelector$3
};

function singleElement_encode(encoder_domElementRepresentation, v) {
  return Js_dict.fromArray([
              [
                "elementNode",
                t_encode$1(encoder_domElementRepresentation, v.elementNode)
              ],
              [
                "textNode",
                Decco.optionToJson(t_encode, v.textNode)
              ],
              [
                "startOffset",
                Decco.intToJson(v.startOffset)
              ],
              [
                "endOffset",
                Decco.intToJson(v.endOffset)
              ],
              [
                "selectedText",
                Decco.stringToJson(v.selectedText)
              ]
            ]);
}

function singleElement_decode(decoder_domElementRepresentation, v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var elementNode = t_decode$1(decoder_domElementRepresentation, Belt_Option.getWithDefault(Js_dict.get(dict$1, "elementNode"), null));
  if (elementNode.TAG === /* Ok */0) {
    var textNode = Decco.optionFromJson(t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "textNode"), null));
    if (textNode.TAG === /* Ok */0) {
      var startOffset = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "startOffset"), null));
      if (startOffset.TAG === /* Ok */0) {
        var endOffset = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "endOffset"), null));
        if (endOffset.TAG === /* Ok */0) {
          var selectedText = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "selectedText"), null));
          if (selectedText.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      elementNode: elementNode._0,
                      textNode: textNode._0,
                      startOffset: startOffset._0,
                      endOffset: endOffset._0,
                      selectedText: selectedText._0
                    }
                  };
          }
          var e = selectedText._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".selectedText" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
        }
        var e$1 = endOffset._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".endOffset" + e$1.path,
                  message: e$1.message,
                  value: e$1.value
                }
              };
      }
      var e$2 = startOffset._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".startOffset" + e$2.path,
                message: e$2.message,
                value: e$2.value
              }
            };
    }
    var e$3 = textNode._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".textNode" + e$3.path,
              message: e$3.message,
              value: e$3.value
            }
          };
  }
  var e$4 = elementNode._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".elementNode" + e$4.path,
            message: e$4.message,
            value: e$4.value
          }
        };
}

function adjacentText_encode(v) {
  return Js_dict.fromArray([
              [
                "text",
                Decco.stringToJson(v.text)
              ],
              [
                "selector",
                Selector$SmartcutsMacros.selector_encode(v.selector)
              ],
              [
                "textNodeIndex",
                Decco.intToJson(v.textNodeIndex)
              ]
            ]);
}

function adjacentText_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var text = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "text"), null));
  if (text.TAG === /* Ok */0) {
    var selector = Selector$SmartcutsMacros.selector_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "selector"), null));
    if (selector.TAG === /* Ok */0) {
      var textNodeIndex = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "textNodeIndex"), null));
      if (textNodeIndex.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  text: text._0,
                  selector: selector._0,
                  textNodeIndex: textNodeIndex._0
                }
              };
      }
      var e = textNodeIndex._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".textNodeIndex" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = selector._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".selector" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = text._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".text" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function crossNodes_encode(encoder_domElementRepresentation, v) {
  return Js_dict.fromArray([
              [
                "start",
                t_encode$4(encoder_domElementRepresentation, v.start)
              ],
              [
                "end_",
                t_encode$4(encoder_domElementRepresentation, v.end_)
              ],
              [
                "selectedText",
                Decco.stringToJson(v.selectedText)
              ],
              [
                "prevAdjacentText",
                Decco.optionToJson(adjacentText_encode, v.prevAdjacentText)
              ],
              [
                "nextAdjacentText",
                Decco.optionToJson(adjacentText_encode, v.nextAdjacentText)
              ]
            ]);
}

function crossNodes_decode(decoder_domElementRepresentation, v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var start = t_decode$4(decoder_domElementRepresentation, Belt_Option.getWithDefault(Js_dict.get(dict$1, "start"), null));
  if (start.TAG === /* Ok */0) {
    var end_ = t_decode$4(decoder_domElementRepresentation, Belt_Option.getWithDefault(Js_dict.get(dict$1, "end_"), null));
    if (end_.TAG === /* Ok */0) {
      var selectedText = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "selectedText"), null));
      if (selectedText.TAG === /* Ok */0) {
        var prevAdjacentText = Decco.optionFromJson(adjacentText_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "prevAdjacentText"), null));
        if (prevAdjacentText.TAG === /* Ok */0) {
          var nextAdjacentText = Decco.optionFromJson(adjacentText_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "nextAdjacentText"), null));
          if (nextAdjacentText.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      start: start._0,
                      end_: end_._0,
                      selectedText: selectedText._0,
                      prevAdjacentText: prevAdjacentText._0,
                      nextAdjacentText: nextAdjacentText._0
                    }
                  };
          }
          var e = nextAdjacentText._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".nextAdjacentText" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
        }
        var e$1 = prevAdjacentText._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".prevAdjacentText" + e$1.path,
                  message: e$1.message,
                  value: e$1.value
                }
              };
      }
      var e$2 = selectedText._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".selectedText" + e$2.path,
                message: e$2.message,
                value: e$2.value
              }
            };
    }
    var e$3 = end_._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".end_" + e$3.path,
              message: e$3.message,
              value: e$3.value
            }
          };
  }
  var e$4 = start._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".start" + e$4.path,
            message: e$4.message,
            value: e$4.value
          }
        };
}

function t_encode$7(encoder_domElementRepresentation, v) {
  if (v.TAG === /* SingleNode */0) {
    return [
            "SingleNode",
            singleElement_encode(encoder_domElementRepresentation, v._0)
          ];
  } else {
    return [
            "CrossNodes",
            crossNodes_encode(encoder_domElementRepresentation, v._0)
          ];
  }
}

function t_decode$7(decoder_domElementRepresentation, v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "CrossNodes" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = crossNodes_decode(decoder_domElementRepresentation, Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* CrossNodes */1,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "SingleNode" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = singleElement_decode(decoder_domElementRepresentation, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* SingleNode */0,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function stringifyAdjacentText(param) {
  return "{text: " + (StringUtils$SmartcutsMacros.quote(param.text) + (", selector: " + (Selector$SmartcutsMacros.stringify(undefined, false, param.selector) + (", textNodeIndex: " + (String(param.textNodeIndex) + "}")))));
}

function stringify$3(stringifyDomElementRepresentation, selection) {
  if (selection.TAG === /* SingleNode */0) {
    var match = selection._0;
    var textNode = match.textNode;
    return "SingleNode({elementNode: " + (stringify$1(stringifyDomElementRepresentation, match.elementNode) + (", textNode: " + ((
                  textNode !== undefined ? stringify(textNode) : "undefined"
                ) + (", startOffset: " + (String(match.startOffset) + (", endOffset: " + (String(match.endOffset) + (", selectedText: " + (StringUtils$SmartcutsMacros.quote(match.selectedText) + "})")))))))));
  }
  var match$1 = selection._0;
  return "CrossNodes({start: " + (stringify$2(stringifyDomElementRepresentation, match$1.start) + ("end_: " + (stringify$2(stringifyDomElementRepresentation, match$1.end_) + (", selectedText: " + (StringUtils$SmartcutsMacros.quote(match$1.selectedText) + (", prevAdjacentText: " + (OptionUtils$SmartcutsMacros.withDefault("undefined", OptionUtils$SmartcutsMacros.map(match$1.prevAdjacentText, stringifyAdjacentText)) + (", nextAdjacentText: " + (OptionUtils$SmartcutsMacros.withDefault("undefined", OptionUtils$SmartcutsMacros.map(match$1.nextAdjacentText, stringifyAdjacentText)) + "})")))))))));
}

function extractTexts(selection) {
  if (selection.TAG === /* SingleNode */0) {
    var match = selection._0;
    var text = OptionUtils$SmartcutsMacros.withDefault("", OptionUtils$SmartcutsMacros.map(match.textNode, (function (textNode) {
                return textNode.text;
              })));
    var prefix = text.slice(0, match.startOffset);
    var suffix = text.slice(match.endOffset);
    return [
            prefix,
            match.selectedText,
            suffix
          ];
  }
  var match$1 = selection._0;
  var nextAdjacentText = match$1.nextAdjacentText;
  var prevAdjacentText = match$1.prevAdjacentText;
  var match$2 = extractTextAndOffset(match$1.start);
  var match$3 = extractTextAndOffset(match$1.end_);
  var prefix$1 = match$2[0].slice(0, match$2[1]);
  var suffix$1 = match$3[0].slice(match$3[1]);
  var prefixWithAdjacentText = prevAdjacentText !== undefined ? prevAdjacentText.text + prefix$1 : prefix$1;
  var suffixWithAdjacentText = nextAdjacentText !== undefined ? suffix$1 + nextAdjacentText.text : suffix$1;
  return [
          prefixWithAdjacentText,
          match$1.selectedText,
          suffixWithAdjacentText
        ];
}

function extractBoundaryPair(selection) {
  if (selection.TAG === /* SingleNode */0) {
    var match = selection._0;
    var textNode = match.textNode;
    var elementNode = match.elementNode;
    return [
            {
              elementNode: elementNode,
              textNode: textNode,
              offset: match.startOffset
            },
            {
              elementNode: elementNode,
              textNode: textNode,
              offset: match.endOffset
            }
          ];
  }
  var match$1 = selection._0;
  return [
          match$1.start,
          match$1.end_
        ];
}

function extractSelectors(selectorFromDomElementRepresentation, selection) {
  if (selection.TAG === /* SingleNode */0) {
    return [Curry._1(selectorFromDomElementRepresentation, selection._0.elementNode.domElementRepresentation)];
  }
  var match = selection._0;
  return [
          Curry._1(selectorFromDomElementRepresentation, match.start.elementNode.domElementRepresentation),
          Curry._1(selectorFromDomElementRepresentation, match.end_.elementNode.domElementRepresentation)
        ];
}

var Generic = {
  singleElement_encode: singleElement_encode,
  singleElement_decode: singleElement_decode,
  adjacentText_encode: adjacentText_encode,
  adjacentText_decode: adjacentText_decode,
  crossNodes_encode: crossNodes_encode,
  crossNodes_decode: crossNodes_decode,
  t_encode: t_encode$7,
  t_decode: t_decode$7,
  stringifyAdjacentText: stringifyAdjacentText,
  stringify: stringify$3,
  extractTexts: extractTexts,
  extractBoundaryPair: extractBoundaryPair,
  extractSelectors: extractSelectors
};

function t_encode$8(v) {
  return t_encode$7(DomElementIdentifierPaired__WithSelector$SmartcutsMacros.t_encode, v);
}

function t_decode$8(v) {
  return t_decode$7(DomElementIdentifierPaired__WithSelector$SmartcutsMacros.t_decode, v);
}

function fromSelectionSnapshot(domElementIdentifierGenerator, selectionSnapshot) {
  if (!selectionSnapshot) {
    return Util$SmartcutsMacros.logAndRaiseJsError("Expected selectionSnapshot to have a range when NonInputSelection.ForRecording.fromSelectionSnapshot()");
  }
  var match = selectionSnapshot._0;
  var selectedText = match.selectedText;
  var endOffset = match.endOffset;
  var endNode = match.endNode;
  var startOffset = match.startOffset;
  var startNode = match.startNode;
  var start = ofNodeAndOffset(domElementIdentifierGenerator, startNode, startOffset);
  if (startNode === endNode) {
    return {
            TAG: /* SingleNode */0,
            _0: {
              elementNode: start.elementNode,
              textNode: start.textNode,
              startOffset: startOffset,
              endOffset: endOffset,
              selectedText: selectedText
            }
          };
  }
  var end_ = ofNodeAndOffset(domElementIdentifierGenerator, endNode, endOffset);
  var arg = Webapi__Dom__Element.ofNode(match.rootNode);
  var rootElement = (function (param) {
        return OptionUtils$SmartcutsMacros.getExn(param, arg);
      })("Expected rootNode to be an Element if startNode != endNode");
  var textContents = TextContents$SmartcutsMacros.ForRecordingAndAuthoring.fromElement(domElementIdentifierGenerator, rootElement);
  var maybeSearchResultForStartNode = TextContents$SmartcutsMacros.ForRecordingAndAuthoring.searchNode(domElementIdentifierGenerator, startNode, textContents);
  var maybeSearchResultForEndNode = endOffset === 0 ? undefined : TextContents$SmartcutsMacros.ForRecordingAndAuthoring.searchNode(domElementIdentifierGenerator, endNode, textContents);
  return {
          TAG: /* CrossNodes */1,
          _0: {
            start: start,
            end_: end_,
            selectedText: selectedText,
            prevAdjacentText: OptionUtils$SmartcutsMacros.andThen((function (param) {
                    var match = Belt_List.get(textContents, param.index - 1 | 0);
                    if (match === undefined) {
                      return ;
                    }
                    if (match.TAG === /* TextSegment */0) {
                      var match$1 = match._0;
                      if (match$1.TAG !== /* NonEmptySegment */0) {
                        return {
                                text: "",
                                selector: match$1._0.selector,
                                textNodeIndex: -1
                              };
                      }
                      var match$2 = match$1._0;
                      return {
                              text: match$2.text,
                              selector: match$2.parentElement.selector,
                              textNodeIndex: match$2.textNodeIndex
                            };
                    }
                    var match$3 = match._0;
                    if (match$3.TAG !== /* NonEmptySegment */0) {
                      return {
                              text: "",
                              selector: match$3._0.selector,
                              textNodeIndex: -1
                            };
                    }
                    var match$4 = match$3._0;
                    return {
                            text: match$4.text,
                            selector: match$4.parentElement.selector,
                            textNodeIndex: 0
                          };
                  }), maybeSearchResultForStartNode),
            nextAdjacentText: OptionUtils$SmartcutsMacros.andThen((function (param) {
                    var match = Belt_List.get(textContents, param.index + 1 | 0);
                    if (match === undefined) {
                      return ;
                    }
                    if (match.TAG === /* TextSegment */0) {
                      var match$1 = match._0;
                      if (match$1.TAG !== /* NonEmptySegment */0) {
                        return {
                                text: "",
                                selector: match$1._0.selector,
                                textNodeIndex: -1
                              };
                      }
                      var match$2 = match$1._0;
                      return {
                              text: match$2.text,
                              selector: match$2.parentElement.selector,
                              textNodeIndex: match$2.textNodeIndex
                            };
                    }
                    var match$3 = match._0;
                    if (match$3.TAG !== /* NonEmptySegment */0) {
                      return {
                              text: "",
                              selector: match$3._0.selector,
                              textNodeIndex: -1
                            };
                    }
                    var match$4 = match$3._0;
                    return {
                            text: match$4.text,
                            selector: match$4.parentElement.selector,
                            textNodeIndex: 0
                          };
                  }), maybeSearchResultForEndNode)
          }
        };
}

function fromDomSelection(domElementIdentifierGenerator, domSelection) {
  return fromSelectionSnapshot(domElementIdentifierGenerator, Selection__Snapshot$SmartcutsMacros.Regular.fromDomSelection(domSelection));
}

function extractSelectors$1(param) {
  return extractSelectors((function (param) {
                return param.selector;
              }), param);
}

function actsOnSameNodeAsOtherSelection(selectionA, selectionB) {
  var match = extractBoundaryPair(selectionA);
  var match$1 = extractBoundaryPair(selectionB);
  if (isSame$1(match[0], match$1[0])) {
    return true;
  } else {
    return isSame$1(match[1], match$1[1]);
  }
}

function endsOnNode$1(node, selection) {
  var match = extractBoundaryPair(selection);
  return endsOnNode(node, match[1]);
}

function updateSelector$4(f, selection) {
  if (selection.TAG === /* SingleNode */0) {
    var singleElement = selection._0;
    return {
            TAG: /* SingleNode */0,
            _0: {
              elementNode: updateSelector(f, singleElement.elementNode),
              textNode: singleElement.textNode,
              startOffset: singleElement.startOffset,
              endOffset: singleElement.endOffset,
              selectedText: singleElement.selectedText
            }
          };
  }
  var crossNodes = selection._0;
  return {
          TAG: /* CrossNodes */1,
          _0: {
            start: updateSelector$2(f, crossNodes.start),
            end_: updateSelector$2(f, crossNodes.end_),
            selectedText: crossNodes.selectedText,
            prevAdjacentText: crossNodes.prevAdjacentText,
            nextAdjacentText: crossNodes.nextAdjacentText
          }
        };
}

var ForRecording = {
  t_encode: t_encode$8,
  t_decode: t_decode$8,
  fromSelectionSnapshot: fromSelectionSnapshot,
  fromDomSelection: fromDomSelection,
  extractSelectors: extractSelectors$1,
  actsOnSameNodeAsOtherSelection: actsOnSameNodeAsOtherSelection,
  endsOnNode: endsOnNode$1,
  updateSelector: updateSelector$4
};

function t_encode$9(v) {
  return t_encode$7(Selector$SmartcutsMacros.selector_encode, v);
}

function t_decode$9(v) {
  return t_decode$7(Selector$SmartcutsMacros.selector_decode, v);
}

function fromRecording(selection) {
  if (selection.TAG === /* SingleNode */0) {
    var singleNode = selection._0;
    return {
            TAG: /* SingleNode */0,
            _0: {
              elementNode: fromElementNodeForRecording(singleNode.elementNode),
              textNode: singleNode.textNode,
              startOffset: singleNode.startOffset,
              endOffset: singleNode.endOffset,
              selectedText: singleNode.selectedText
            }
          };
  }
  var crossNodes = selection._0;
  return {
          TAG: /* CrossNodes */1,
          _0: {
            start: fromSelectionBoundaryForRecording(crossNodes.start),
            end_: fromSelectionBoundaryForRecording(crossNodes.end_),
            selectedText: crossNodes.selectedText,
            prevAdjacentText: crossNodes.prevAdjacentText,
            nextAdjacentText: crossNodes.nextAdjacentText
          }
        };
}

function updateSelector$5(f, selection) {
  if (selection.TAG === /* SingleNode */0) {
    var singleElement = selection._0;
    return {
            TAG: /* SingleNode */0,
            _0: {
              elementNode: updateSelector$1(f, singleElement.elementNode),
              textNode: singleElement.textNode,
              startOffset: singleElement.startOffset,
              endOffset: singleElement.endOffset,
              selectedText: singleElement.selectedText
            }
          };
  }
  var crossNodes = selection._0;
  return {
          TAG: /* CrossNodes */1,
          _0: {
            start: updateSelector$3(f, crossNodes.start),
            end_: updateSelector$3(f, crossNodes.end_),
            selectedText: crossNodes.selectedText,
            prevAdjacentText: crossNodes.prevAdjacentText,
            nextAdjacentText: crossNodes.nextAdjacentText
          }
        };
}

function extractSelectors$2(param) {
  return extractSelectors((function (selector) {
                return selector;
              }), param);
}

var ForNonRecording = {
  t_encode: t_encode$9,
  t_decode: t_decode$9,
  fromRecording: fromRecording,
  updateSelector: updateSelector$5,
  extractSelectors: extractSelectors$2
};

var SelectionSnapshot;

exports.SelectionSnapshot = SelectionSnapshot;
exports.TextNode = TextNode;
exports.ElementNode = ElementNode;
exports.ElementNodeForRecording = ElementNodeForRecording;
exports.ElementNodeForNonRecording = ElementNodeForNonRecording;
exports.SelectionBoundary = SelectionBoundary;
exports.SelectionBoundaryForRecording = SelectionBoundaryForRecording;
exports.SelectionBoundaryForNonRecording = SelectionBoundaryForNonRecording;
exports.Generic = Generic;
exports.ForRecording = ForRecording;
exports.ForNonRecording = ForNonRecording;
/* Webapi__Dom__Node Not a pure module */
